<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <div class="text-center text-h5 font-weight-light">
          <strong>AGENDA DE HORÁRIOS</strong>
        </div>
      </v-col>
      <v-btn-toggle v-model="index" rounded mandatory>
        <v-btn ref="teste" outlined color="purple" @click="loadVisible(1)">Aulas Coletivas</v-btn>
        <v-btn outlined color="pink" @click="loadVisible(2)">Musculação</v-btn>
      </v-btn-toggle>
    </v-row>
    <v-row>
      <inline-calendar v-model="inline" @change="InlineCalendarEvent" class="pb-0 mb-0" />
    </v-row>
    <div v-if="visivel()" fluid class="d-flex justify-center align-center flex-column mb-6">
      <div class="pa-2">
        <v-img
          src="@/assets/empty-state.jpg"
          transition="fade"
          max-width="300"
          style="opacity: 0.4"
        ></v-img>
      </div>
      <div class="pa-2 font-weight-light">Nenhuma aula cadastrada para mostrar!</div>
    </div>
    <div class="d-flex justify-center align-stretch mt-10 pt-10" v-if="loadingVisible">
      <v-progress-circular :size="50" color="primary lighten-3" fixed indeterminate></v-progress-circular>
    </div>
    <v-list v-else-if="isMember">
      <v-list-item v-for="(item) in classSchedulesList" :key="item.id">
        <v-list-item-content class="pa-0 ma-1">
          <v-card class="d-flex pa-0" outlined>
            <div class="float-top">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="item.class.classType == $tipoAula('COLETIVAS')"
                    color="purple"
                    v-bind="attrs"
                    v-on="on"
                  >mdi-bookmark</v-icon>
                  <v-icon v-else color="pink" v-bind="attrs" v-on="on">mdi-bookmark</v-icon>
                </template>
                <span v-if="item.class.classType == $tipoAula('COLETIVAS')">Coletiva</span>
                <span v-else>Musculação</span>
              </v-tooltip>
            </div>
            <v-col v-if="isMember">
              <div>
                <v-switch
                  height="0"
                  class="m-0 p-0"
                  @change="doSchedule(item,$event)"
                  v-model="item.scheduled"
                  :disabled="item.checkedIn"
                ></v-switch>
              </div>
            </v-col>
            <v-col>
              <div>
                <span class="text-caption">Hora de início</span>
                <h4>{{ item.timeStart }}</h4>
              </div>
            </v-col>
            <v-col>
              <div>
                <span class="text-caption">Aula</span>
                <h4>{{ item.class.name }}</h4>
              </div>
            </v-col>
            <v-col>
              <div>
                <span class="text-caption">Reservas</span>
                <h4
                  v-if="item.qtdSchedules >= item.class.maxCapacity"
                  class="red--text"
                >{{ item.qtdSchedules + ' - ' + item.class.maxCapacity}}</h4>
                <h4 v-else>{{ item.qtdSchedules + ' - ' + item.class.maxCapacity }}</h4>
              </div>
            </v-col>
            <v-col class="d-none d-sm-flex">
              <div>
                <span class="text-caption">Professor</span>
                <h4>{{ item.coachName }}</h4>
              </div>
            </v-col>
            <v-col class="d-none d-sm-flex">
              <div>
                <span class="text-caption">Local</span>
                <h4>{{ item.classRoom }}</h4>
              </div>
            </v-col>
            <v-card-actions v-if="!isMember">
              <!-- <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>-->
            </v-card-actions>
          </v-card>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else class="pl-0 ma-0">
      <v-list-group
        v-for="(item) in classSchedulesList"
        :key="item.id"
        @click="setCurrentClassSchdeule(item)"
        :value="false"
        :ripple="false"
      >
        <template v-slot:activator>
          <v-list-item class="pa-0 ma-0">
            <v-list-item-content class="pa-0 ma-1">
              <v-card class="d-flex pa-0" outlined>
                <div class="float-top">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-if="item.class.classType == $tipoAula('COLETIVAS')"
                        color="purple"
                        v-bind="attrs"
                        v-on="on"
                      >mdi-bookmark</v-icon>
                      <v-icon v-else color="pink" v-bind="attrs" v-on="on">mdi-bookmark</v-icon>
                    </template>
                    <span v-if="item.class.classType == $tipoAula('COLETIVAS')">Coletiva</span>
                    <span v-else>Musculação</span>
                  </v-tooltip>
                </div>
                <v-col>
                  <div>
                    <span class="text-caption">Hora de início</span>
                    <h4>{{ item.timeStart }}</h4>
                  </div>
                </v-col>
                <v-col>
                  <div>
                    <span class="text-caption">Aula</span>
                    <h4>{{ item.class.name }}</h4>
                  </div>
                </v-col>
                <v-col>
                  <div>
                    <span class="text-caption">Reservas</span>
                    <h4
                      v-if="item.qtdSchedules >= item.class.maxCapacity"
                      class="red--text"
                    >{{ item.qtdSchedules + ' - ' + item.class.maxCapacity}}</h4>
                    <h4 v-else>{{ item.qtdSchedules + ' - ' + item.class.maxCapacity }}</h4>
                  </div>
                </v-col>
                <v-col class="d-none d-sm-flex">
                  <div>
                    <span class="text-caption">Professor</span>
                    <h4>{{ item.coachName }}</h4>
                  </div>
                </v-col>
                <v-col class="d-none d-sm-flex">
                  <div>
                    <span class="text-caption">Local</span>
                    <h4>{{ item.classRoom }}</h4>
                  </div>
                </v-col>
                <v-card-actions v-if="!isMember">
                  <!-- <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>-->
                </v-card-actions>
              </v-card>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item v-if="visivelSchedule" class="d-flex justify-center align-center">
          <div v-if="loadingScheduleVisible">
            <v-progress-circular :size="20" color="primary lighten-3" fixed indeterminate></v-progress-circular>
          </div>
          <div v-else class="pa-2 font-weight-light">Nenhum agendamento feito!</div>
        </v-list-item>
        <v-list-item v-else v-for="(schedule, x) in schedulesList" :key="x">
          <v-list-item-content>
            <v-list-item-title>{{schedule.member.name}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
//import moment from "moment";

import InlineCalendar from "@/components/InlineCalendar";

export default {
  components: { InlineCalendar },
  data: () => ({
    index: 1,
    currentClassSchedule: null,
    loadingVisible: true,
    loadingScheduleVisible: true,
    inline: null,
    polling: null,
    pollingSchedule: null,
    classType: 2,
    calendarSelectedDate: null,
  }),
  methods: {
    ...mapActions("snackbar", ["ActionSetSnackbar"]),
    ...mapActions("units", [
      "ActionFindClassSchedulesList",
      "ActionDoSchedule",
      "ActionRemoveSchedule",
      "ActionSetClassSchedulesList",
      "ActionSetSchedulesList",
      "ActionFindSchedulesList",
    ]),
    loadVisible(classType) {
      this.loadingVisible = true;
      this.classType = classType;

      this.findClassList();
    },
    getDate() {
      let d = new Date();
      return d;
    },
    InlineCalendarEvent(e) {
      this.loadingVisible = true;
      this.calendarSelectedDate = e;
      this.findClassList();
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    pollData() {
      this.polling = setInterval(() => {
        this.findClassList();
      }, 20000);
    },
    pollDataSchedule() {
      this.pollingSchedule = setInterval(() => {
        this.findScheduleList();
      }, 40000);
    },
    refresh() {
      const { name } = this.$route;
      if (name === "class-schedules") {
        return this.findClassList();
      }
    },
    async doSchedule(item, e) {
      let schedule = {
        idMember: this.user.id,
        idClassSchedule: item.id,
        scheduledDate: this.calendarSelectedDate.completeDate,
      };
      try {
        if (e === true) {
          await this.ActionDoSchedule(schedule);
        } else {
          await this.ActionRemoveSchedule(schedule);
        }
      } catch (error) {
        //e = !e;
        console.log("doSchedule", error);
      }
      await this.findClassList();
    },
    async findClassList() {
      let params = {
        unitId: this.currentUnit.id,
        classType: this.classType,
        scheduledDate: this.calendarSelectedDate.completeDate,
      };

      console.log("params.scheduledDate", params.scheduledDate);
      if (!params.scheduledDate) params.scheduledDate = new Date();

      if (this.isMember === true) {
        params.idMember = this.user.id;
      }
      try {
        await this.ActionFindClassSchedulesList(params);
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingVisible = false;
      }
    },
    setCurrentClassSchdeule(classSchedule) {
      this.ActionSetSchedulesList(null);
      this.loadingScheduleVisible = true;

      this.currentClassSchedule = classSchedule;
      this.findScheduleList();
    },
    async findScheduleList() {
      try {
        if (this.currentClassSchedule === null) return;

        await this.ActionFindSchedulesList(this.currentClassSchedule);
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingScheduleVisible = false;
      }
    },
    visivel() {
      if (
        (this.classSchedulesList === null ||
          this.classSchedulesList.length === 0) &&
        this.loadingVisible === false
      )
        return true;
      else return false;
    },
  },
  mounted() {
    this.findClassList();
    this.refresh();
    this.pollData();
    this.pollDataSchedule();
    this.scrollToTop();
  },
  beforeDestroy() {
    clearInterval(this.polling);
    clearInterval(this.pollingSchedule);

    this.ActionSetClassSchedulesList(null);
  },
  computed: {
    ...mapState("units", [
      "classSchedulesList",
      "currentUnit",
      "schedulesList",
    ]),
    ...mapState("auth", ["user", "isMember"]),
    // ...mapState("showClass", ["classSchedule"]),
    visivelSchedule() {
      if (this.schedulesList === null || this.schedulesList.length === 0)
        return true;
      else return false;
    },
  },
};
</script>
<style scoped>
.v-list-item__icon {
  padding: 0 !important;
  margin: 0 !important;
  max-width: 0 !important;
}

.v-list-group__header__append-icon {
  padding: 0 !important;
  margin: 0 !important;
  max-width: 0 !important;
}
</style>
